/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

jQuery(function($){

 
 

if ($('#jw-latest-post-div').length > 0) {
  function jwInitLatestPostSlider() {
  var $slider = $('.jw-latest-post-section-inner');
  var mobileBreakpoint = 767;

  if ($(window).width() <= mobileBreakpoint) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        adaptiveHeight: false
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

  $.getJSON("https://blog.tessuti.com.au/blog-api/?apikey=fjpU39wuZVjzHTRzZZjdVgxxWg", function (result) {
    $.each(result, function (key, val) {
      var jw_url = val.url;
      var jw_title = val.title;
      var jw_image = val.image;
      var jw_content = val.content;

      var target_item = 'jw-latest-post-section-item-' + key;

      $('#' + target_item + ' .jw-latest-post-section-item-img').html(
        '<a href="' + jw_url + '" target="_blank"><img src="' + jw_image + '" /></a>'
      );
      $('#' + target_item + ' .jw-latest-post-section-item-title').html('<h4>' + jw_title + '</h4>');
      $('#' + target_item + ' .jw-latest-post-section-item-text').html('<p>' + jw_content + '</p>');
      $('#' + target_item + ' .jw-latest-post-section-item-button > a').attr('href', jw_url);
    });

    jwInitLatestPostSlider();
  });

  $(window).on('resize orientationchange', function () {
    jwInitLatestPostSlider();
  });
}

  if($('#jw-combine-prd').length >0){
  
     // Step 1: On page load, trigger click based on hidden input value
      var initialVariantId = $('input[name="id"]').val();
      $('#jw-gallery-target-var-id-' + initialVariantId).trigger('click');
    
      // Step 2: On select change, update hidden input and trigger new gallery item
      $('.jw-color-option-selector.single-option-selector').on('change', function() {
        setTimeout(function() {
        //var selectedVarId = $(this).find('option:selected').data('var-id');
        var selectedVarId = $('input[name="id"]').val();
        // Update the hidden input value
       // $('input[name="id"]').val(selectedVarId);
    //console.log(selectedVarId);
        // Trigger gallery change
        $('#jw-gallery-target-var-id-' + selectedVarId).trigger('click');
      }, 200); // 1000 milliseconds = 1 second
      
  });
  }


 if($('#jw_fabric_metre_prd').length >0 ){ 
      
 // get_rendered_price();
 // dynamic_price_multiple_currency();

   
     /* function set_up_meter_and_yard_label(meter){
        meter = parseFloat(meter);
        if(meter < 0.25){
          meter = 0.25;
        }
      
         if(meter != 0.25){
            yard = meter * 1.094;
      
            yard = (Math.round(yard * 100) / 100).toFixed(2);
        
            $('#jw_fabric_meter').text(meter.toFixed(2));
            $('#jw_fabric_yard').text(yard);
            cal_total_price();
         }
        
      }*/

    // Attach an event listener to the input field
   /* $('#shopify_quantity_fake input[name="quantity_fake"]').on('blur', function() {
      // Get the value entered by the user
      var inputValue = parseFloat($(this).val());
      if(inputValue < 0){
        inputValue = 0.25;
      }else{
        
      }

      var roundedValue = inputValue;
      // Check if the value is a multiple of 0.25
      if (inputValue % 0.25 !== 0) {
        // Round the value to the nearest multiple of 0.25
        roundedValue = Math.round(inputValue * 4) / 4;
        
        // Update the value of the input field
        $(this).val(roundedValue.toFixed(2));
        
        // Calculate the number of 0.25 increments
        var numIncrements = Math.floor(roundedValue/ 0.25);
        
        // Calculate the integer value
        var intValue = Math.max(numIncrements, 1);
        
        // Update the other quantity field
        $('#shopify_quantity input[name="quantity"]').val(intValue);
      } else {
        roundedValue = inputValue.toFixed(2);
        $(this).val(roundedValue);
      
        // If the value is already a multiple of 0.25, update the other quantity field with the integer value
        var numIncrements = Math.floor(inputValue / 0.25);
        var intValue = Math.max(numIncrements, 1);
        $('#shopify_quantity input[name="quantity"]').val(intValue);
      }
  
      set_up_meter_and_yard_label(roundedValue);
      
    });*/
      fabric_quantity_add();
    function fabric_quantity_add() {
      const $meterDisplay = $('#jw_fabric_meter');
      const $yardDisplay = $('#jw_fabric_yard');
      const $quantityInput = $('#shopify_quantity_fake input[name="quantity_fake"]');
      const $shopifyQuantity = $('#shopify_quantity input[name="quantity"]'); // Scoped selector
    
      const step = 0.25;
      const min = 0.25;
      const conversionRate = 1.094;
    
      function updateValues(newMeter) {
        const newYard = (newMeter * conversionRate).toFixed(2);
        const realQuantity = Math.round(newMeter / step); // Convert to Shopify integer
    
        $meterDisplay.text(newMeter.toFixed(2));
        $yardDisplay.text(newYard);
        $quantityInput.val(newMeter.toFixed(2));
        $shopifyQuantity.val(realQuantity);
        cal_total_price(); // Uncomment if needed
      }
    
      // Minus button
      $('#shopify_quantity_fake .minus').on('click', function () {
        let currentMeter = parseFloat($meterDisplay.text()) || 0;
    
        if (currentMeter > min) {
          updateValues(currentMeter - step);
        }
      });
    
      // Plus button
      $('#shopify_quantity_fake .plus').on('click', function () {
        let currentMeter = parseFloat($meterDisplay.text()) || 0;
        updateValues(currentMeter + step);
      });
    
      // Manual input on blur
      $quantityInput.on('blur', function () {
        let newMeter = parseFloat($(this).val());
    
        if (isNaN(newMeter) || newMeter < min) {
          newMeter = min;
        }
    
        // Round to nearest step (0.25)
        newMeter = Math.round(newMeter / step) * step;
    
        updateValues(newMeter);
      });
    }

   setTimeout(cal_total_price, 1000); // adjust delay if needed
   function cal_total_price() {
      const $unitPrice = $('.jw_fabric_price_notes .buckscc-money');
      const $realQuantity = $('#shopify_quantity input[name="quantity"]');
      const $priceOutput = $('#jw_dynamic_price');
      const $currencyLabel = $('.bucks-selected'); // e.g., "EUR", "USD"
     //console.log('ddd');
      if (!$unitPrice.length || !$realQuantity.length) return;

    
      const unitCount = parseInt($realQuantity.val(), 10) || 0;
    
      const unitPriceTextRaw = $unitPrice.text().trim(); // e.g., "€7,80 EUR" or "$8.86 USD"
      const numericMatch = unitPriceTextRaw.match(/[\d.,]+/);
      if (!numericMatch) return;
    
      let priceString = numericMatch[0]; // e.g., "7,80" or "8.86"
    
      // If comma is used but no dot, treat comma as decimal
      if (priceString.includes(',') && !priceString.includes('.')) {
        priceString = priceString.replace(',', '.');
      } else {
        priceString = priceString.replace(/,/g, ''); // Remove thousands separator
      }
    
      const unitPrice = parseFloat(priceString) || 0;
      const total = unitPrice * unitCount;
    
      const currencySymbol = (unitPriceTextRaw.match(/^[^\d]+/) || [''])[0].trim();
      const currencyCode = $currencyLabel.text().trim(); // e.g., EUR, USD
    
      let formattedTotal = `${currencySymbol}${total.toFixed(2)} ${currencyCode}`;
    
      // If EUR, replace dot with comma
      if (currencyCode === 'EUR') {
        formattedTotal = formattedTotal.replace('.', ',');
      }
    
      $priceOutput.text(formattedTotal);
    }

   initCurrencyChangeListener();
    function initCurrencyChangeListener() {
      // When user changes the dropdown manually
        $('#bucksSelector').on('change', function () {
          // Run price calculation after a short delay to let the app update DOM
          setTimeout(cal_total_price, 100);
        });
      
        // When user clicks currency list (desktop UI)
        $(document).on('click', '.converterTriggers', function () {
          // Run price calculation after currency app switches value
          setTimeout(cal_total_price, 100);
        });
      }


   
  
      
      /*function cal_total_price(){
        var currency = $('.currency-item.selected').first().text();
        if($('#if-quarter-meter-dropdown-variants').length > 0){//if using quarter-meter-dropdown-variants product template
          var price_per_unit = $('.jw-quarter-meter-dropdown-variants-unit-price > span:last-child').text().match(/[\d\.]+/)[0];
          //console.log(price_per_unit);
        }else{
          var price_per_unit = $('.price.productPrice > p:last-child > span:last-child').text().match(/[\d\.]+/)[0];
        }
        //console.log(price_per_unit);
        var quantity = $('#shopify_quantity .qty').val();
        var total_price = quantity * price_per_unit;
      
        total_price = (Math.round(total_price * 100) / 100).toFixed(2)
      
        $('#jw_dynamic_price').text(currency + " " + total_price.toString());
        if($('#if-quarter-meter-dropdown-variants').length > 0){//if using quarter-meter-dropdown-variants product template
           var total_metre_price = 4 * price_per_unit;
          
           total_metre_price = (Math.round(total_metre_price * 100) / 100).toFixed(2)
          $('#target-jw-quarter-meter-dropdown-variants-one-metre-price').text(currency + " " + total_metre_price.toString());
        }
      }
      
      function rend_dynamic_price(){
        if($('#if-quarter-meter-dropdown-variants').length > 0){//if using quarter-meter-dropdown-variants product template
          var price = $('.jw-quarter-meter-dropdown-variants-unit-price > span:last-child').text()
          price = price.match(/[\d\.]+/)[0]
          var currency = $('.jw-quarter-meter-dropdown-variants-unit-price > span:last-child').data('currency');
        }else{  
          var price = $('.price.productPrice > p:last-child > span:last-child').text()
          price = price.match(/[\d\.]+/)[0]
          var currency = $('.price.productPrice > p:last-child > span:last-child').data('currency');
        }  
        $('#jw_dynamic_price').text(currency + ' ' + price);
        //if($('#if-quarter-meter-dropdown-variants').length > 0){//if using quarter-meter-dropdown-variants product template
           //$('#target-jw-quarter-meter-dropdown-variants-total-price').text(currency + ' ' + price);
        //}
      }
      
       
      
      function get_rendered_price(){
        t = setInterval(function(){
          var mydiv = $('#jw_fabric span:last-child').data('currency');
          if (mydiv) {
              rend_dynamic_price();
              //console.log(mydiv);
              clearInterval(t);
          }
       }, 500);
      }
      
      
      
      
      function dynamic_price_multiple_currency(){
        $('.currency-list ul li a').on('click', function(){
            if($('#if-quarter-meter-dropdown-variants').length > 0){//if using quarter-meter-dropdown-variants product template
             var price_per_unit = $('.jw-quarter-meter-dropdown-variants-unit-price > span:last-child').text();
            }else{
              var price_per_unit = $('.price.productPrice > p:last-child > span:last-child').text();
            }
          t = setInterval(function(){
              if($('#if-quarter-meter-dropdown-variants').length > 0){//if using quarter-meter-dropdown-variants product template
                 var price_per_unit_new = $('.jw-quarter-meter-dropdown-variants-unit-price > span:last-child').text();
              }else{
                 var price_per_unit_new = $('.price.productPrice > p:last-child > span:last-child').text();
              }
          
            
            if (price_per_unit != price_per_unit_new) {
                cal_total_price();
                clearInterval(t);
            }
         }, 500);
        });
      }*/
 }


 if($('#jw_current_prd_handle').length > 0){
   var handle = $('#jw_current_prd_handle').val();

    var redirectMap = {
      'gutermann-sew-all-polyester-thread-100m-1': 'gutermann-sew-all-polyester-thread-100m',
      'gutermann-sew-all-polyester-thread-100m-2': 'gutermann-sew-all-polyester-thread-100m',
      'gutermann-sew-all-polyester-thread-100m-3': 'gutermann-sew-all-polyester-thread-100m',
      'mettler-metrosene-sewing-thread-150m-1': 'mettler-metrosene-sewing-thread-150m',
      'mettler-metrosene-sewing-thread-150m-2': 'mettler-metrosene-sewing-thread-150m'
    };

    if (redirectMap[handle]) {
      // Carry the query string (and hash) over to the combined page, otherwise a deep
      // link such as /products/...-150m-1?variant=49621616197934 - which is also what
      // Shopify's /variants/<id> permalink redirects to - loses the variant and lands
      // on the default colour. Uses replace() so the -1 / -2 URL is not left in history.
      window.location.replace(
        "/products/" + redirectMap[handle] + window.location.search + window.location.hash
      );
    }
 } 


    // Check if there are any swatch labels for color options
  /*if ($('.jw-swatch-circle').length > 0) {
    
    // Add click handler to each color swatch label
    $('.jw-swatch-circle').on('click', function () {
      // Get the 'for' attribute value (ID of the related input)
      const inputId = $(this).attr('for');

      // Try to find the corresponding input
      const inputEl = $('#' + inputId);
      if (inputEl.length > 0) {
        const value = inputEl.val();

        // Check if the selected color text element exists
        const selectedTextEl = $('#jw-selected-color-text');
        if (selectedTextEl.length > 0 && value) {
          selectedTextEl.text(value);
        }
      }
    });

  }*/

    
 if($('#jw-signup-modal').length >0){
  var $modal = $('#jw-signup-modal');

  // OPEN
  $(document).on('click', '.jw_countdown_signup', function (e) {
    e.preventDefault();
    $modal.addClass('is-open');
    $('body').addClass('jw-modal-open');
  });

  // CLOSE (overlay + X)
  $(document).on('click', '[data-jw-close]', function () {
    $modal.removeClass('is-open');
    $('body').removeClass('jw-modal-open');
  });
}


// Only run if the discount input field exists on the page
if ($('#jw-cart-discount-input').length) {

  $(document).on('click', '.cart__checkout', function (e) {
    const $btn = $(this);
    const $form = $btn.closest('form');
    const code = $('#jw-cart-discount-input').val().trim();

    if (code) {
      e.preventDefault();

      // Prevent duplicate clicks while processing
      $btn.prop('disabled', true);

      $.ajax({
        url: '/cart',
        method: 'POST',
        data: $form.serialize(),
        success: function () {
          // Redirect to checkout with discount code applied
          window.location.href = '/checkout?discount=' + encodeURIComponent(code);
        },
        error: function () {
          // If POST fails, still redirect to avoid blocking the user
          window.location.href = '/checkout?discount=' + encodeURIComponent(code);
        },
        complete: function () {
          $btn.prop('disabled', false);
        }
      });
    }
    // No discount code entered, allow form to submit normally
  });

}


// Shipping & Returns accordion
if ($('.jw-shipping-returns-wrapper').length) {

  // Hide accordion content on load
  $('.jw-shipping-returns-wrapper .jw-policy-content').hide();

  // Toggle accordion item
  $('.jw-shipping-returns-wrapper .jw-policy-title').on('click', function () {

    var $section = $(this).closest('.jw-policy-section');
    var $content = $section.find('.jw-policy-content');

    // Close current item
    if ($section.hasClass('active')) {

      $section.removeClass('active');
      $content.stop(true, true).slideUp(250);

    } else {

      // Open current item only
      $section.addClass('active');
      $content.stop(true, true).slideDown(250);

    }

  });

}
  
});

/*-----------------------------------------------------------------------------/
/ jw: Header dropdown search
/ Opens snippets/jw-header-search.liquid under the header instead of the
/ theme's side search drawer. Triggers: .js-jw-header-search-trigger
/-----------------------------------------------------------------------------*/
(function () {
  var OPEN_CLASS = 'is-open';
  var body = document.body;
  var lastTrigger = null;

  // Query lazily so it still works after the header section is re-rendered in the theme editor
  function getPanel() {
    return document.querySelector('[data-jw-header-search]');
  }

  function isOpen() {
    var panel = getPanel();
    return !!panel && panel.classList.contains(OPEN_CLASS);
  }

  function setTriggersExpanded(expanded) {
    document.querySelectorAll('.js-jw-header-search-trigger').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  // Transparent header (homepage) turns solid while body has [header-menu-open]
  function holdHeaderSolid() {
    if (!body.hasAttribute('header-menu-open')) body.setAttribute('header-menu-open', '');
  }

  function releaseHeaderSolid() {
    if (!document.querySelector('.js-header details[open]')) body.removeAttribute('header-menu-open');
  }

  function open(trigger) {
    var panel = getPanel();
    if (!panel) return;

    lastTrigger = trigger || null;
    document.documentElement.classList.add('jw-header-search-open');
    panel.removeAttribute('inert');
    panel.classList.add(OPEN_CLASS);
    setTriggersExpanded(true);
    holdHeaderSolid();

    // Focus synchronously so the iOS keyboard opens within the tap gesture
    var input = panel.querySelector('input[type="search"]');
    if (input) input.focus({ preventScroll: true });
  }

  function close(returnFocus) {
    var panel = getPanel();
    if (!panel || !isOpen()) return;

    document.documentElement.classList.remove('jw-header-search-open');
    panel.classList.remove(OPEN_CLASS);
    panel.setAttribute('inert', '');
    setTriggersExpanded(false);
    releaseHeaderSolid();

    var predictiveSearch = panel.querySelector('predictive-search');
    if (predictiveSearch && typeof predictiveSearch.close === 'function') predictiveSearch.close();

    var input = panel.querySelector('input[type="search"]');
    if (input) {
      input.value = '';
      input.blur();
    }

    if (returnFocus && lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-jw-header-search-trigger');
    if (trigger) {
      e.preventDefault();
      if (isOpen()) {
        close();
      } else {
        open(trigger);
      }
      return;
    }

    if (e.target.closest('.js-jw-header-search-close')) {
      e.preventDefault();
      close(true);
      return;
    }

    // Click outside the panel
    var panel = getPanel();
    if (isOpen() && panel && !panel.contains(e.target)) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close(true);
  });

  // Theme drawers (mobile menu, cart) open on touchend and swallow the click, so close on popup open too
  if (window.jQuery) {
    jQuery(document).on('mfpOpen', function () {
      close();
    });
  }

  new MutationObserver(function () {
    if (!isOpen()) return;

    // Header hidden on scroll down ("Hide on scroll" header style)
    if (body.classList.contains('header-up')) {
      close();
      return;
    }

    // A mega menu closing removes [header-menu-open]; keep the header solid while search is open
    holdHeaderSolid();
  }).observe(body, { attributes: true, attributeFilter: ['class', 'header-menu-open'] });
})();

/* ==========================================================================
   jw: Boost instant search (ISW) – no results message
   Boost's ISW template renders 'search.resultEmptyWithSuggestion', which has no
   store translation, so its built-in fallback "Sorry, nothing found for "…".
   Check out these items instead?" shows. Strip the second sentence in the ISW
   dropdown only (the full search results page renders its own template).
   ========================================================================== */
(function () {
  var DESC = '.boost-sd__instant-search-no-product .boost-sd__no-search-result-desc';
  var EXTRA = /\s*Check out these items instead\?\s*/;

  function clean(desc) {
    var walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (EXTRA.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(EXTRA, '');
    }
  }

  function scan(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    if (!el) return;
    var desc = el.closest(DESC);
    if (desc) clean(desc);
    el.querySelectorAll(DESC).forEach(clean);
  }

  scan(document.body);

  // Boost re-renders the dropdown on every keystroke
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scan);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
